// extracted by mini-css-extract-plugin
module.exports = {"container":"container-GCDsX","button":"button-1LcEc","button_delete":"button_delete-3M3CK"};